import { addressString } from 'components/FormattedAddress';
import Moment from 'moment';
import ReportStatus from 'constants/ReportStatus';

// Prüfen ob ein Passwort den Anforderungen entspricht
export const checkPasswordRequirements = (password, { minPasswordLength = 8, minPasswordCatgories = 2 }) => {
	// Prüfen ob password gesetzt und vom Typ String ist
	if (!password || typeof password !== 'string') return false;
	// Prüfen ob die Länge des Passworts ausreichend ist
	if (password.length < minPasswordLength) return false;
	// Prüfen ob das Passwort Zeichen aus der geforderten Anzahl Kategorien enthält
	let validCategoriesCounter = 0;
	const lowerCase = password.match(/[a-z]+/);
	const upperCase = password.match(/[A-Z]+/);
	const numbers = password.match(/[0-9]+/);
	const specialChars = password.match(/[\!\@\#\$\%\=\?\_\.\,\:\;\-]/);
	if (lowerCase) validCategoriesCounter++;
	if (upperCase) validCategoriesCounter++;
	if (numbers) validCategoriesCounter++;
	if (specialChars) validCategoriesCounter++;
	if (validCategoriesCounter < minPasswordCatgories) return false;
	return true;
};

// Prüfen ob der übergebene String dem Email-Format entspricht
export const checkEmailFormat = email => {
	var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w+)+$/;
	if (email.match(mailformat)) return true;
	return false;
};

String.prototype.pick = function(min, max) {
	var n,
		chars = '';

	if (typeof max === 'undefined') {
		n = min;
	} else {
		n = min + Math.floor(Math.random() * (max - min + 1));
	}

	for (var i = 0; i < n; i++) {
		chars += this.charAt(Math.floor(Math.random() * this.length));
	}

	return chars;
};

String.prototype.shuffle = function() {
	var array = this.split('');
	var tmp,
		current,
		top = array.length;

	if (top)
		while (--top) {
			current = Math.floor(Math.random() * (top + 1));
			tmp = array[current];
			array[current] = array[top];
			array[top] = tmp;
		}

	return array.join('');
};

// Generiere ein gültiges Passwort mit Mindestlänge
export const randomPassword = (minPasswordLength = 8) => {
	const specials = '!@#$%=?_-';
	const lowerCase = 'abcdefghijkmnopqrstuvwxyz';
	const upperCase = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
	const numbers = '0123456789';
	const all = `${specials}${lowerCase}${upperCase}${numbers}`;
	let password = '';
	password += specials.pick(1);
	password += lowerCase.pick(1);
	password += upperCase.pick(1);
	password += all.pick(minPasswordLength - 3 < 5 ? 5 : minPasswordLength - 3, minPasswordLength);
	return password.shuffle();
};

export const stringFilter = (filter, row) => {
	const id = filter.pivotId || filter.id;
	const string = row[id] || '';
	return row[id] !== undefined ? String(string.toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true;
};

export const typeFilter = (filter, row) => {
	return row.type !== undefined ? String(row.type.name.toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true;
};

export const supTypeFilter = (filter, row) => {
	let name = '';
	switch (row.supType) {
		case '1':
			name = 'Beschwerde';
			break;
		case '2':
			name = 'Anregung';
			break;
		case '3':
			name = 'Dank/Lob';
			break;
		case '4':
			name = 'Sonstiger Hinweis';
			break;
	}
	return row.supType !== undefined ? String(name.toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true;
};

export const addressFilter = (filter, row) => {
	return row.address !== undefined ? String(addressString({ address: row.address }).toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true;
};

export const dateFilter = (filter, row) => {
	const id = filter.pivotId || filter.id;
	return row[id] !== undefined ? String(Moment(row[id]).format('DD.MM.YYYY HH:mm')).indexOf(filter.value) > -1 : true;
};

export const deadlineSortMethod = (a, b, desc) => {
	a = !a || !a.deadline ? (desc ? -Infinity : Infinity) : Moment(a.deadline).valueOf();
	b = !b || !b.deadline ? (desc ? -Infinity : Infinity) : Moment(b.deadline).valueOf();

	if (a > b) return 1;

	if (a < b) return -1;

	return 0;
};

export const idFilter = (filter, row) => {
	const id = filter.pivotId || filter.id;
	if (typeof row[id] === 'object') {
		const filteredId = [row[id].id, ...row[id].connectedIds].find(id =>
			String(id.toString().toLowerCase()).startsWith(filter.value.toLowerCase())
		);
		return filteredId ? true : false;
	}
	return row[id] !== undefined ? String(row[id].toString().toLowerCase()).startsWith(filter.value.toLowerCase()) : true;
};

export const responsibleFilter = (filter, row) => {
	return row.responsible !== undefined ? String(row.responsible.name.toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true;
};

export const strPreview = (string, maxLength, centerEllipsis) => {
	if (typeof string !== 'string') {
		console.log('Invalid input (Has to be of type string)', string);
		return '';
	}
	if (!maxLength) return string;
	return string.length >= maxLength
		? centerEllipsis
			? `${string.substring(0, Math.floor(maxLength / 2))}...${string.slice(string.length - Math.floor(maxLength / 2))}`
			: `${string.substring(0, maxLength)}...`
		: string;
};

export const byteStr = size => {
	if (size < 1024) return `${size} Byte`;
	if (size < Math.pow(1024, 2)) return `${Math.ceil(size / 1024)} KB`;
	if (size < Math.pow(1024, 3)) return `${Math.ceil(size / Math.pow(1024, 2))} MB`;
};

export const getTypeIcon = (typeId, status, iconType) => {
	return `https://www.meldooplus.de/api/v2/images/typemarker/${typeId}/${status === 7 ? 'green' : status === 8 || status === 3 ? 'red' : 'orange'}`;
};

// Funktion sollte String zum Status einheitlich ausgeben
export const statusString = status => {};



// WEBPACK FOOTER //
// ./helperfunctions/index.js